<template>
  <div class="link">
    <div class="header">
      <img src="@/assets/logo.png" alt="Logo WEV.nu" class="logo">
    </div>
    <div class="load" :class="{ active: Loader }">
      <img src="@/assets/logo.png" alt="Logo WEV.nu" class="logo">
      <Vue3Lottie class="animation" :animationData="require('@/assets/animations/dog.json')" :loop="true" />
      <span>Gegevens ophalen...</span>
    </div>
    <div class="intro" v-if="Step == 'Start' || Step == 'Complete'" :class="{ center: Step == 'Complete' }">
      <span v-if="Step == 'Start'">Je bent uitgenodigd door <b>{{ Reseller }}</b> om een waardebepaling van je voertuig op te stellen.</span>
      <span v-if="Step == 'Complete'"><b>Bedankt voor je bestanden.</b> We gaan er mee aan de slag. Klik op afronden om deze link te blokkeren.</span>
    </div>
    <div class="content" v-if="Step == 'Start'">
      <span class="tip">Kenteken</span>
      <input class="licence" type="text" v-model="License" @change="CheckLicense()" disabled>
      <span class="vehicle" v-if="Brand">{{ Brand }} {{ Model }}</span>
      <span class="export" v-if="Export">Let op: het voertuig is geëxporteerd</span>
      <span class="tip">Kilometerstand</span>
      <input class="mileage" type="number" v-model="Mileage" @change="SetValue('D', 'Mileage', Mileage)">
      <div class="buttons">
        <button v-if="License && Mileage" class="next" @click="SkipStep(true)">Volgende stap</button>
        <button v-else class="next disabled">Volgende stap</button>
      </div>
    </div>
    <div class="content full" v-if="Step == 'Client'">
      <span class="subtitle">We hebben je gegevens nodig voor de rapportage.</span>
      <div class="group">
        <span class="tip" v-if="Type == 'B'">Bedrijfsnaam</span>
        <span class="tip" v-else>Naam</span>
        <input v-model="Name" @change="SetValue('C', 'Name', Name)">
      </div>
      <div class="group">
        <span class="tip">Adres</span>
        <input v-model="Street" @change="SetValue('C', 'Street', Street)">
      </div>
      <div class="group">
        <span class="tip">Postcode</span>
        <input v-model="Postcode" @change="SetValue('C', 'Postcode', Postcode)">
      </div>
      <div class="group">
        <span class="tip">Plaats</span>
        <input v-model="City" @change="SetValue('C', 'City', City)">
      </div>
      <div class="group">
        <span class="tip">E-mailadres</span>
        <input v-model="Email" :disabled="HasEmail" @change="SetValue('C', 'Email', Email)">
      </div>
      <div class="buttons">
        <svg class="previous" @click="Step = 'Start'" viewBox="0 0 1024 1024" fill="#000000" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g><path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" fill=""></path></g></svg>
        <button class="next" :class="{ disabled: !(Name && Street && Postcode && City && (/^\S+@\S+\.\S+$/).test(Email)) }" @click="Step = 'Intro'">Volgende stap</button>
      </div>
    </div>
    <div class="content full" v-if="Step == 'Intro'">
      <span class="title">Top, we gaan nu enkele foto's toevoegen van het voertuig.</span>
      <span class="subtitle">Upload foto's vanaf je computer of telefoon. Of maak ze direct in de browser. Geef hiervoor in de volgende stap toegang om je camera te gebruiken.</span>
      <div class="buttons">
        <svg class="previous" @click="SkipStep(false)" viewBox="0 0 1024 1024" fill="#000000" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g><path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" fill=""></path></g></svg>
        <button class="next" @click="Step = 'CAR_V'">Volgende stap</button>
      </div>
    </div>
    
    
    
    <div class="content full" v-if="this.Steps.map(item => item.ID).includes(Step)">
      <span class="title center">{{ Steps.find(item => item.ID == Step).Title }}</span>
      <div class="shutter">
        <div class="cameraGranted" v-if="Permission == 'Granted'">
          <Vue3Lottie class="animation" :animationData="require('@/assets/animations/loader.json')" :loop="true" />
        </div>
        <div class="cameraDenied" v-if="Permission == 'Denied'">
          <span>Je hebt geen toegang gegeven tot de camera. Upload een foto via onderstaande knop. Open de link opnieuw om toegang te geven tot je camera.</span>
        </div>
        <div class="cameraLoader" v-if="CameraLoader">
          <Vue3Lottie class="animation" :animationData="require('@/assets/animations/loader.json')" :loop="true" />
        </div>
        <div class="captured" v-if="Images.filter(image => image.Type == Steps.find(item => item.ID == Step).ID).length" :style="{ background: 'url(' + Images.filter(image => image.Type == Steps.find(item => item.ID == Step).ID)[0].raw + ')' }"></div>
        <div class="empty" v-if="Images.filter(image => image.Type == Step).length == 0 && !Mobile">Upload een foto via de knop hieronder of open de link via je mobiel om de foto's direct te maken</div>
        <video class="preview" id="video" playsinline autoplay muted v-else></video>
      </div>
      <div class="captureButtons">
        <div class="redo" v-if="Images.filter(image => image.Type== Steps.find(item => item.ID == Step).ID).length" @click="Empty()">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2792 3C15.1401 3 15.9044 3.55086 16.1766 4.36754L16.7208 6H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V9C2 7.34315 3.34315 6 5 6H7.27924L7.82339 4.36754C8.09562 3.55086 8.8599 3 9.72076 3H14.2792ZM14.2792 5H9.72076L9.17661 6.63246C8.90438 7.44914 8.1401 8 7.27924 8H5C4.44772 8 4 8.44772 4 9V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9C20 8.44772 19.5523 8 19 8H16.7208C15.8599 8 15.0956 7.44914 14.8234 6.63246L14.2792 5ZM9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5ZM12 8C9.51472 8 7.5 10.0147 7.5 12.5C7.5 14.9853 9.51472 17 12 17C14.4853 17 16.5 14.9853 16.5 12.5C16.5 10.0147 14.4853 8 12 8Z" fill="#0b4d49"></path> </g></svg>
          <span v-if="Mobile">Opnieuw maken</span>
          <span v-else>Opnieuw uploaden</span>
        </div>
        <div class="remove" v-if="Images.filter(image => image.Type== Steps.find(item => item.ID == Step).ID).length" @click="Remove(Steps.find(item => item.ID == Step).ID)">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path d="M20 8.70007H4C3.90151 8.70007 3.80398 8.68067 3.71299 8.64298C3.62199 8.60529 3.53931 8.55005 3.46967 8.4804C3.40003 8.41076 3.34478 8.32808 3.30709 8.23709C3.2694 8.14609 3.25 8.04856 3.25 7.95007C3.25 7.85158 3.2694 7.75405 3.30709 7.66306C3.34478 7.57207 3.40003 7.48939 3.46967 7.41974C3.53931 7.3501 3.62199 7.29486 3.71299 7.25716C3.80398 7.21947 3.90151 7.20007 4 7.20007H20C20.1989 7.20007 20.3897 7.27909 20.5303 7.41974C20.671 7.5604 20.75 7.75116 20.75 7.95007C20.75 8.14899 20.671 8.33975 20.5303 8.4804C20.3897 8.62106 20.1989 8.70007 20 8.70007Z" fill="#0b4d49"></path> <path d="M16.44 20.75H7.56C7.24309 20.7717 6.92503 20.7303 6.62427 20.6281C6.3235 20.5259 6.04601 20.3651 5.80788 20.1548C5.56975 19.9446 5.37572 19.6892 5.23704 19.4034C5.09836 19.1177 5.01779 18.8072 5 18.49V8.00005C5 7.80113 5.07902 7.61037 5.21967 7.46972C5.36032 7.32906 5.55109 7.25005 5.75 7.25005C5.94891 7.25005 6.13968 7.32906 6.28033 7.46972C6.42098 7.61037 6.5 7.80113 6.5 8.00005V18.49C6.5 18.9 6.97 19.25 7.5 19.25H16.38C16.94 19.25 17.38 18.9 17.38 18.49V8.00005C17.38 7.78522 17.4653 7.57919 17.6172 7.42729C17.7691 7.27538 17.9752 7.19005 18.19 7.19005C18.4048 7.19005 18.6109 7.27538 18.7628 7.42729C18.9147 7.57919 19 7.78522 19 8.00005V18.49C18.9822 18.8072 18.9016 19.1177 18.763 19.4034C18.6243 19.6892 18.4303 19.9446 18.1921 20.1548C17.954 20.3651 17.6765 20.5259 17.3757 20.6281C17.075 20.7303 16.7569 20.7717 16.44 20.75ZM16.56 7.75005C16.4611 7.75139 16.363 7.73291 16.2714 7.6957C16.1798 7.65848 16.0966 7.60329 16.0267 7.53337C15.9568 7.46346 15.9016 7.38024 15.8644 7.28864C15.8271 7.19704 15.8087 7.09891 15.81 7.00005V5.51005C15.81 5.10005 15.33 4.75005 14.81 4.75005H9.22C8.67 4.75005 8.22 5.10005 8.22 5.51005V7.00005C8.22 7.19896 8.14098 7.38972 8.00033 7.53038C7.85968 7.67103 7.66891 7.75005 7.47 7.75005C7.27109 7.75005 7.08032 7.67103 6.93967 7.53038C6.79902 7.38972 6.72 7.19896 6.72 7.00005V5.51005C6.75872 4.88136 7.04203 4.29281 7.50929 3.87041C7.97655 3.44801 8.5906 3.22533 9.22 3.25005H14.78C15.4145 3.21723 16.0362 3.43627 16.51 3.8595C16.9838 4.28273 17.2713 4.87592 17.31 5.51005V7.00005C17.3113 7.09938 17.2929 7.19798 17.2558 7.29013C17.2187 7.38228 17.1637 7.46615 17.0939 7.53685C17.0241 7.60756 16.941 7.6637 16.8493 7.70201C16.7577 7.74033 16.6593 7.76006 16.56 7.76005V7.75005Z" fill="#0b4d49"></path> <path d="M10.22 17.0001C10.0219 16.9975 9.83263 16.9177 9.69253 16.7776C9.55244 16.6375 9.47259 16.4482 9.47 16.2501V11.7201C9.47 11.5212 9.54902 11.3304 9.68967 11.1898C9.83032 11.0491 10.0211 10.9701 10.22 10.9701C10.4189 10.9701 10.6097 11.0491 10.7503 11.1898C10.891 11.3304 10.97 11.5212 10.97 11.7201V16.2401C10.9713 16.3394 10.9529 16.438 10.9158 16.5302C10.8787 16.6223 10.8237 16.7062 10.7539 16.7769C10.6841 16.8476 10.601 16.9037 10.5093 16.9421C10.4177 16.9804 10.3193 17.0001 10.22 17.0001Z" fill="#0b4d49"></path> <path d="M13.78 17.0001C13.5811 17.0001 13.3903 16.9211 13.2497 16.7804C13.109 16.6398 13.03 16.449 13.03 16.2501V11.7201C13.03 11.5212 13.109 11.3304 13.2497 11.1898C13.3903 11.0491 13.5811 10.9701 13.78 10.9701C13.9789 10.9701 14.1697 11.0491 14.3103 11.1898C14.451 11.3304 14.53 11.5212 14.53 11.7201V16.2401C14.53 16.4399 14.4513 16.6317 14.3109 16.774C14.1706 16.9162 13.9798 16.9975 13.78 17.0001Z" fill="#0b4d49"></path> </g></svg>
        </div>
        <div class="capture" v-if="Images.filter(image => image.Type== Steps.find(item => item.ID == Step).ID).length == 0 && Permission && Mobile" @click="Capture(Steps.find(item => item.ID == Step).ID)" :class="{ disabled: Permission == 'Denied' || CameraLoader }">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2792 3C15.1401 3 15.9044 3.55086 16.1766 4.36754L16.7208 6H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V9C2 7.34315 3.34315 6 5 6H7.27924L7.82339 4.36754C8.09562 3.55086 8.8599 3 9.72076 3H14.2792ZM14.2792 5H9.72076L9.17661 6.63246C8.90438 7.44914 8.1401 8 7.27924 8H5C4.44772 8 4 8.44772 4 9V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9C20 8.44772 19.5523 8 19 8H16.7208C15.8599 8 15.0956 7.44914 14.8234 6.63246L14.2792 5ZM9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5ZM12 8C9.51472 8 7.5 10.0147 7.5 12.5C7.5 14.9853 9.51472 17 12 17C14.4853 17 16.5 14.9853 16.5 12.5C16.5 10.0147 14.4853 8 12 8Z" fill="#FFFFFF"></path> </g></svg>
          <span>Maak de foto</span>
        </div>
        <div class="upload" v-if="Images.filter(image => image.Type== Steps.find(item => item.ID == Step).ID).length == 0" @click="TriggerUpload()" :class="{ full: !Permission || !Mobile }">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path d="M18.22 20.75H5.78C5.43322 20.7359 5.09262 20.6535 4.77771 20.5075C4.4628 20.3616 4.17975 20.155 3.94476 19.8996C3.70977 19.6442 3.52745 19.3449 3.40824 19.019C3.28903 18.693 3.23525 18.3468 3.25 18V15C3.25 14.8011 3.32902 14.6103 3.46967 14.4697C3.61033 14.329 3.80109 14.25 4 14.25C4.19892 14.25 4.38968 14.329 4.53033 14.4697C4.67099 14.6103 4.75 14.8011 4.75 15V18C4.72419 18.2969 4.81365 18.5924 4.99984 18.8251C5.18602 19.0579 5.45465 19.21 5.75 19.25H18.22C18.5154 19.21 18.784 19.0579 18.9702 18.8251C19.1564 18.5924 19.2458 18.2969 19.22 18V15C19.22 14.8011 19.299 14.6103 19.4397 14.4697C19.5803 14.329 19.7711 14.25 19.97 14.25C20.1689 14.25 20.3597 14.329 20.5003 14.4697C20.641 14.6103 20.72 14.8011 20.72 15V18C20.75 18.6954 20.5041 19.3744 20.0359 19.8894C19.5677 20.4045 18.9151 20.7137 18.22 20.75Z" fill="#0b4d49"></path> <path d="M16 8.74995C15.9015 8.75042 15.8038 8.7312 15.7128 8.69342C15.6218 8.65564 15.5392 8.60006 15.47 8.52995L12 5.05995L8.53 8.52995C8.38782 8.66243 8.19978 8.73455 8.00548 8.73113C7.81118 8.7277 7.62579 8.64898 7.48838 8.51157C7.35096 8.37416 7.27225 8.18877 7.26882 7.99447C7.2654 7.80017 7.33752 7.61213 7.47 7.46995L11.47 3.46995C11.6106 3.3295 11.8012 3.25061 12 3.25061C12.1987 3.25061 12.3894 3.3295 12.53 3.46995L16.53 7.46995C16.6705 7.61058 16.7493 7.8012 16.7493 7.99995C16.7493 8.1987 16.6705 8.38932 16.53 8.52995C16.4608 8.60006 16.3782 8.65564 16.2872 8.69342C16.1962 8.7312 16.0985 8.75042 16 8.74995Z" fill="#0b4d49"></path> <path d="M12 15.75C11.8019 15.7474 11.6126 15.6676 11.4725 15.5275C11.3324 15.3874 11.2526 15.1981 11.25 15V4C11.25 3.80109 11.329 3.61032 11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4V15C12.7474 15.1981 12.6676 15.3874 12.5275 15.5275C12.3874 15.6676 12.1981 15.7474 12 15.75Z" fill="#0b4d49"></path> </g></svg>
        </div>
      </div>
      <div class="buttons">
          <svg class="previous" @click="Step = Steps.find(item => item.ID == Step).Previous" viewBox="0 0 1024 1024" fill="#000000" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g><path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" fill=""></path></g></svg>
          <button class="next" v-if="Images.filter(image => image.Type == Steps.find(item => item.ID == Step).ID).length" @click="Step = Steps.find(item => item.ID == Step).Next">Volgende stap</button>
          <button class="next disabled" v-else>Volgende stap</button>
      </div>
    </div>
    
    
    
    <div class="content" v-if="Step == 'Damage'">
      <span class="title center">Je hebt nu alle verplichte foto's geüpload. Je kan het rapport afronden of foto's toevoegen van de staat van het voertuig.</span>
      <span class="subtitle center">Heeft het voertuig bovenmatige schade aan exterieur of interieur? Dan kan dit effect hebben op de waarde. Upload hiervoor max. 5 extra foto's.</span>
      <div class="buttons">
        <button class="next secondary" @click="Step = 'DAMAGE_1'">Extra foto's toevoegen</button>
      </div>
      <div class="buttons">
        <svg class="previous" @click="Step = 'CAR_INTA'" viewBox="0 0 1024 1024" fill="#000000" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g><path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" fill=""></path></g></svg>
        <button class="next" @click="Close()">Afronden</button>
      </div>
    </div>
    <div class="content full" v-if="Step == 'DAMAGE_1' || Step == 'DAMAGE_2' || Step == 'DAMAGE_3' || Step == 'DAMAGE_4' || Step == 'DAMAGE_5'">
      <span class="title center">Schadefoto's</span>
      <div class="shutter">
        <div class="cameraGranted" v-if="Permission == 'Granted'">
          <Vue3Lottie class="animation" :animationData="require('@/assets/animations/loader.json')" :loop="true" />
        </div>
        <div class="cameraDenied" v-if="Permission == 'Denied'">
          <span>Je hebt geen toegang gegeven tot de camera. Upload een foto via onderstaande knop. Open de link opnieuw om toegang te geven tot je camera.</span>
        </div>
        <div class="cameraLoader" v-if="CameraLoader">
          <Vue3Lottie class="animation" :animationData="require('@/assets/animations/loader.json')" :loop="true" />
        </div>
        <div class="captured" v-if="Images.filter(image => image.Type == Step).length" :style="{ background: 'url(' + Images.filter(image => image.Type == Step)[0].raw + ')' }"></div>
        <div class="empty" v-if="Images.filter(image => image.Type == Step).length == 0 && !Mobile">Upload een foto via de knop hieronder of open de link via je mobiel om de foto's direct te maken</div>
        <video class="preview" id="video" playsinline autoplay muted v-else></video>
      </div>
      <div class="captureButtons">
        <div class="redo" v-if="Images.filter(image => image.Type == Step).length" @click="Empty()">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2792 3C15.1401 3 15.9044 3.55086 16.1766 4.36754L16.7208 6H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V9C2 7.34315 3.34315 6 5 6H7.27924L7.82339 4.36754C8.09562 3.55086 8.8599 3 9.72076 3H14.2792ZM14.2792 5H9.72076L9.17661 6.63246C8.90438 7.44914 8.1401 8 7.27924 8H5C4.44772 8 4 8.44772 4 9V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9C20 8.44772 19.5523 8 19 8H16.7208C15.8599 8 15.0956 7.44914 14.8234 6.63246L14.2792 5ZM9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5ZM12 8C9.51472 8 7.5 10.0147 7.5 12.5C7.5 14.9853 9.51472 17 12 17C14.4853 17 16.5 14.9853 16.5 12.5C16.5 10.0147 14.4853 8 12 8Z" fill="#0b4d49"></path> </g></svg>
          <span v-if="Mobile">Opnieuw maken</span>
          <span v-else>Opnieuw uploaden</span>
        </div>
        <div class="remove" v-if="Images.filter(image => image.Type == Step).length" @click="Remove(Step)">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path d="M20 8.70007H4C3.90151 8.70007 3.80398 8.68067 3.71299 8.64298C3.62199 8.60529 3.53931 8.55005 3.46967 8.4804C3.40003 8.41076 3.34478 8.32808 3.30709 8.23709C3.2694 8.14609 3.25 8.04856 3.25 7.95007C3.25 7.85158 3.2694 7.75405 3.30709 7.66306C3.34478 7.57207 3.40003 7.48939 3.46967 7.41974C3.53931 7.3501 3.62199 7.29486 3.71299 7.25716C3.80398 7.21947 3.90151 7.20007 4 7.20007H20C20.1989 7.20007 20.3897 7.27909 20.5303 7.41974C20.671 7.5604 20.75 7.75116 20.75 7.95007C20.75 8.14899 20.671 8.33975 20.5303 8.4804C20.3897 8.62106 20.1989 8.70007 20 8.70007Z" fill="#0b4d49"></path> <path d="M16.44 20.75H7.56C7.24309 20.7717 6.92503 20.7303 6.62427 20.6281C6.3235 20.5259 6.04601 20.3651 5.80788 20.1548C5.56975 19.9446 5.37572 19.6892 5.23704 19.4034C5.09836 19.1177 5.01779 18.8072 5 18.49V8.00005C5 7.80113 5.07902 7.61037 5.21967 7.46972C5.36032 7.32906 5.55109 7.25005 5.75 7.25005C5.94891 7.25005 6.13968 7.32906 6.28033 7.46972C6.42098 7.61037 6.5 7.80113 6.5 8.00005V18.49C6.5 18.9 6.97 19.25 7.5 19.25H16.38C16.94 19.25 17.38 18.9 17.38 18.49V8.00005C17.38 7.78522 17.4653 7.57919 17.6172 7.42729C17.7691 7.27538 17.9752 7.19005 18.19 7.19005C18.4048 7.19005 18.6109 7.27538 18.7628 7.42729C18.9147 7.57919 19 7.78522 19 8.00005V18.49C18.9822 18.8072 18.9016 19.1177 18.763 19.4034C18.6243 19.6892 18.4303 19.9446 18.1921 20.1548C17.954 20.3651 17.6765 20.5259 17.3757 20.6281C17.075 20.7303 16.7569 20.7717 16.44 20.75ZM16.56 7.75005C16.4611 7.75139 16.363 7.73291 16.2714 7.6957C16.1798 7.65848 16.0966 7.60329 16.0267 7.53337C15.9568 7.46346 15.9016 7.38024 15.8644 7.28864C15.8271 7.19704 15.8087 7.09891 15.81 7.00005V5.51005C15.81 5.10005 15.33 4.75005 14.81 4.75005H9.22C8.67 4.75005 8.22 5.10005 8.22 5.51005V7.00005C8.22 7.19896 8.14098 7.38972 8.00033 7.53038C7.85968 7.67103 7.66891 7.75005 7.47 7.75005C7.27109 7.75005 7.08032 7.67103 6.93967 7.53038C6.79902 7.38972 6.72 7.19896 6.72 7.00005V5.51005C6.75872 4.88136 7.04203 4.29281 7.50929 3.87041C7.97655 3.44801 8.5906 3.22533 9.22 3.25005H14.78C15.4145 3.21723 16.0362 3.43627 16.51 3.8595C16.9838 4.28273 17.2713 4.87592 17.31 5.51005V7.00005C17.3113 7.09938 17.2929 7.19798 17.2558 7.29013C17.2187 7.38228 17.1637 7.46615 17.0939 7.53685C17.0241 7.60756 16.941 7.6637 16.8493 7.70201C16.7577 7.74033 16.6593 7.76006 16.56 7.76005V7.75005Z" fill="#0b4d49"></path> <path d="M10.22 17.0001C10.0219 16.9975 9.83263 16.9177 9.69253 16.7776C9.55244 16.6375 9.47259 16.4482 9.47 16.2501V11.7201C9.47 11.5212 9.54902 11.3304 9.68967 11.1898C9.83032 11.0491 10.0211 10.9701 10.22 10.9701C10.4189 10.9701 10.6097 11.0491 10.7503 11.1898C10.891 11.3304 10.97 11.5212 10.97 11.7201V16.2401C10.9713 16.3394 10.9529 16.438 10.9158 16.5302C10.8787 16.6223 10.8237 16.7062 10.7539 16.7769C10.6841 16.8476 10.601 16.9037 10.5093 16.9421C10.4177 16.9804 10.3193 17.0001 10.22 17.0001Z" fill="#0b4d49"></path> <path d="M13.78 17.0001C13.5811 17.0001 13.3903 16.9211 13.2497 16.7804C13.109 16.6398 13.03 16.449 13.03 16.2501V11.7201C13.03 11.5212 13.109 11.3304 13.2497 11.1898C13.3903 11.0491 13.5811 10.9701 13.78 10.9701C13.9789 10.9701 14.1697 11.0491 14.3103 11.1898C14.451 11.3304 14.53 11.5212 14.53 11.7201V16.2401C14.53 16.4399 14.4513 16.6317 14.3109 16.774C14.1706 16.9162 13.9798 16.9975 13.78 17.0001Z" fill="#0b4d49"></path> </g></svg>
        </div>
        <div class="capture" v-if="Images.filter(image => image.Type == Step).length == 0 && Permission && Mobile" @click="Capture(Step)" :class="{ disabled: Permission == 'Denied' || CameraLoader }">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2792 3C15.1401 3 15.9044 3.55086 16.1766 4.36754L16.7208 6H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V9C2 7.34315 3.34315 6 5 6H7.27924L7.82339 4.36754C8.09562 3.55086 8.8599 3 9.72076 3H14.2792ZM14.2792 5H9.72076L9.17661 6.63246C8.90438 7.44914 8.1401 8 7.27924 8H5C4.44772 8 4 8.44772 4 9V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V9C20 8.44772 19.5523 8 19 8H16.7208C15.8599 8 15.0956 7.44914 14.8234 6.63246L14.2792 5ZM9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5ZM12 8C9.51472 8 7.5 10.0147 7.5 12.5C7.5 14.9853 9.51472 17 12 17C14.4853 17 16.5 14.9853 16.5 12.5C16.5 10.0147 14.4853 8 12 8Z" fill="#FFFFFF"></path> </g></svg>
          <span>Maak de foto</span>
        </div>
        <div class="upload" v-if="Images.filter(image => image.Type == Step).length == 0" @click="TriggerUpload()" :class="{ full: !Permission || !Mobile }">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g> <path d="M18.22 20.75H5.78C5.43322 20.7359 5.09262 20.6535 4.77771 20.5075C4.4628 20.3616 4.17975 20.155 3.94476 19.8996C3.70977 19.6442 3.52745 19.3449 3.40824 19.019C3.28903 18.693 3.23525 18.3468 3.25 18V15C3.25 14.8011 3.32902 14.6103 3.46967 14.4697C3.61033 14.329 3.80109 14.25 4 14.25C4.19892 14.25 4.38968 14.329 4.53033 14.4697C4.67099 14.6103 4.75 14.8011 4.75 15V18C4.72419 18.2969 4.81365 18.5924 4.99984 18.8251C5.18602 19.0579 5.45465 19.21 5.75 19.25H18.22C18.5154 19.21 18.784 19.0579 18.9702 18.8251C19.1564 18.5924 19.2458 18.2969 19.22 18V15C19.22 14.8011 19.299 14.6103 19.4397 14.4697C19.5803 14.329 19.7711 14.25 19.97 14.25C20.1689 14.25 20.3597 14.329 20.5003 14.4697C20.641 14.6103 20.72 14.8011 20.72 15V18C20.75 18.6954 20.5041 19.3744 20.0359 19.8894C19.5677 20.4045 18.9151 20.7137 18.22 20.75Z" fill="#0b4d49"></path> <path d="M16 8.74995C15.9015 8.75042 15.8038 8.7312 15.7128 8.69342C15.6218 8.65564 15.5392 8.60006 15.47 8.52995L12 5.05995L8.53 8.52995C8.38782 8.66243 8.19978 8.73455 8.00548 8.73113C7.81118 8.7277 7.62579 8.64898 7.48838 8.51157C7.35096 8.37416 7.27225 8.18877 7.26882 7.99447C7.2654 7.80017 7.33752 7.61213 7.47 7.46995L11.47 3.46995C11.6106 3.3295 11.8012 3.25061 12 3.25061C12.1987 3.25061 12.3894 3.3295 12.53 3.46995L16.53 7.46995C16.6705 7.61058 16.7493 7.8012 16.7493 7.99995C16.7493 8.1987 16.6705 8.38932 16.53 8.52995C16.4608 8.60006 16.3782 8.65564 16.2872 8.69342C16.1962 8.7312 16.0985 8.75042 16 8.74995Z" fill="#0b4d49"></path> <path d="M12 15.75C11.8019 15.7474 11.6126 15.6676 11.4725 15.5275C11.3324 15.3874 11.2526 15.1981 11.25 15V4C11.25 3.80109 11.329 3.61032 11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4V15C12.7474 15.1981 12.6676 15.3874 12.5275 15.5275C12.3874 15.6676 12.1981 15.7474 12 15.75Z" fill="#0b4d49"></path> </g></svg>
        </div>
      </div>
      <div class="gallery">
        <div class="image" @click="Step = 'DAMAGE_1'" :class="{ active : Step == 'DAMAGE_1' }" :style="SetBackground('DAMAGE_1')"><span class="number">1</span></div>
        <div class="image" @click="Step = 'DAMAGE_2'" :class="{ active : Step == 'DAMAGE_2' }" :style="SetBackground('DAMAGE_2')"><span class="number">2</span></div>
        <div class="image" @click="Step = 'DAMAGE_3'" :class="{ active : Step == 'DAMAGE_3' }" :style="SetBackground('DAMAGE_3')"><span class="number">3</span></div>
        <div class="image" @click="Step = 'DAMAGE_4'" :class="{ active : Step == 'DAMAGE_4' }" :style="SetBackground('DAMAGE_4')"><span class="number">4</span></div>
        <div class="image" @click="Step = 'DAMAGE_5'" :class="{ active : Step == 'DAMAGE_5' }" :style="SetBackground('DAMAGE_5')"><span class="number">5</span></div>
      </div>
      <div class="buttons">
        <svg class="previous" @click="Step = 'Damage'" viewBox="0 0 1024 1024" fill="#000000" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g><path d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z" fill=""></path></g></svg>
        <button class="next" @click="Close()">Afronden</button>
      </div>
    </div>
    <div class="content" v-if="Step == 'Complete'">
      <Vue3Lottie class="animation" style="margin: 50px 0;" :animationData="require('@/assets/animations/check.json')" :loop="false" />
    </div>
    <div class="content" v-if="Step == 'Oops'">
      <Vue3Lottie class="animation" :animationData="require('@/assets/animations/error.json')" :loop="true" />
      <span class="subtitle center">De link is ongeldig of verlopen. Neem contact op met je administratiekantoor voor een nieuwe link.</span>
    </div>
    <canvas hidden style="display: none; opacity: 0;" class="previewCanvas"></canvas>
    <input hidden style="display: none; opacity: 0;" type="file" name="uploadCanvas" class="uploadCanvas" accept="image/jpeg, image/png" @change="Upload()">
  </div>
</template>

<script>
// COMPRESS
import * as imageConversion from 'image-conversion';

export default {
  name: 'PublicLink',

  data () {
    return {
      Loader: true,
      Mobile: false,
      Step: 'Start',
      Steps: [
        {
          ID: 'CAR_V',
          Previous: 'Intro',
          Next: 'CAR_L',
          Title: 'Voorkant voertuig'
        },
        {
          ID: 'CAR_L',
          Previous: 'CAR_V',
          Next: 'CAR_A',
          Title: 'Linkerzijkant voertuig'
        },
        {
          ID: 'CAR_A',
          Previous: 'CAR_L',
          Next: 'CAR_R',
          Title: 'Achterkant voertuig'
        },
        {
          ID: 'CAR_R',
          Previous: 'CAR_A',
          Next: 'CAR_KM',
          Title: 'Rechterzijkant voertuig'
        },
        {
          ID: 'CAR_KM',
          Previous: 'CAR_R',
          Next: 'CAR_INTV',
          Title: 'Kilometerstand'
        },
        {
          ID: 'CAR_INTV',
          Previous: 'CAR_KM',
          Next: 'CAR_INTA',
          Title: 'Interieur voorkant'
        },
        {
          ID: 'CAR_INTA',
          Previous: 'CAR_INTV',
          Next: 'Damage',
          Title: 'Interieur achterkant'
        }
      ],
      License: '',
      Brand: '',
      Model: '',
      Type: '',
      Mileage: '',
      Export: false,
      Skip: false,
      Name: '',
      Adres: '',
      Postcode: '',
      Email: '',
      City: '',
      HasEmail: true,
      Permission: 'Unknown',
      CameraLoader: false,
      Reseller: [],
      Images: []
    }
  },

  mounted () {
    this.CheckLink()
    this.CheckMobile()
  },

  methods: {
    CheckLink () {
      this.$http.get(`https://app.wev.nu/api/link/${this.$route.params.id}`).then((response) => {
        if(response.data.dossier) {
          this.License = response.data.dossier.License
          this.Mileage = response.data.dossier.Mileage
          if(response.data.dossier.ClientEmail) { this.Email = response.data.dossier.ClientEmail } else { this.HasEmail = false }
          this.Type = response.data.dossier.Type
          this.Reseller = response.data.dossier.ResellerName

          this.Name = response.data.dossier.ClientName
          this.Street = response.data.dossier.ClientStreet
          this.Postcode = response.data.dossier.ClientPostcode
          this.City = response.data.dossier.ClientCity

          if(response.data.skip) {
            this.Skip = true
          }

          if(response.data.media) {
            this.Images = response.data.media
          }

          this.Loader = false
        } else {
          this.Step = 'Oops'
          this.Loader = false
        }
      })
    },

    CheckMobile () {
      if(window.screen.width < 500) {
        this.Mobile = true
      } else {
        this.Mobile = false
      }
    },

    CheckCamera () {
      navigator.permissions.query({ name: "camera" }).then(res => {
        if(res.state == 'granted') {
          return true
        } else {
          return false
        }
      })
    },

    CheckLicense () {
      this.$http.get(`https://app.wev.nu/api/link/rdw/${this.License}`).then((response) => {
        this.Brand = response.data.rdw[0].merk
        this.Model = response.data.rdw[0].handelsbenaming
        this.Type = response.data.rdw[0].voertuigsoort

        if(response.data.rdw[0].export_indicator == 'Ja') {
          this.Export = true
        }
      })
    },

    StartVideo () {
      this.StopVideo()
      var self = this
      setTimeout(function(){
        const videoElement = document.querySelector('.preview')
        navigator.mediaDevices.getUserMedia({
          audio: false,
          video: { width: 1920, height: 1080, facingMode: "environment", aspectRatio: { exact: 1/1 } }
        }).then(stream => {
          self.Permission = 'Granted'
          videoElement.srcObject = stream
          document.querySelector('.previewCanvas').width = stream.getTracks()[0].getSettings().width
          document.querySelector('.previewCanvas').height = stream.getTracks()[0].getSettings().height
        }).catch(error => {
          self.Permission = 'Denied'
          console.error("Failed to get user media", error)
        })
      }, 100)
    },

    StopVideo () {
      const video = document.querySelector('video')
      if(video) {
        if(video.srcObject) {
          const mediaStream = video.srcObject
          const tracks = mediaStream.getTracks()
          tracks.forEach(track => track.stop())
        }
      }
    },

    async Capture () {
      var self = this
      setTimeout(function() {
        const canvas = document.querySelector('.previewCanvas')
        const videoElement = document.querySelector('.preview')
        canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height)
        self.Upload(canvas.toDataURL('image/jpeg'))
        self.CameraLoader = true
      }, 100)
    },

    Empty () {
      this.Images = this.Images.filter(image => image.Type !== this.Step)
      if(this.Mobile) {
        this.StartVideo()
      }
    },

    Remove () {
      this.Images = this.Images.filter(image => image.Type !== this.Step)
      this.StartVideo()
      this.$http.get(`https://app.wev.nu/api/link/delete/${this.$route.params.id}/${this.Step}`)
    },

    TriggerUpload () {
      document.querySelector('.uploadCanvas').click()
    },

    SetValue (Secret, Field, V) {
      if(V) {
        var Value = V
      } else {
        Value = this.Field
      }

      this.$http.patch(`https://app.wev.nu/api/link/${this.$route.params.id}`, {
        Secret,
        Field,
        Value
      })
    },

    Upload (f) {
      this.CameraLoader = true
      var File = ''
      if(f) {
        var blobBin = atob(f.split(',')[1])
        var array = []
        for(var i = 0; i < blobBin.length; i++) {
            array.push(blobBin.charCodeAt(i))
        }
        File = new Blob([new Uint8Array(array)], {type: 'image/jpeg'})
      } else {
        File = document.querySelector('.uploadCanvas').files[0]
      }
      
      var formData = new FormData()
      imageConversion.compress(File, {
        width: 1920,
        quality: 0.9,
        type: "image/jpeg"
      }).then((response) => {
        formData.append('type', 'image/jpeg')
        formData.append('image', response)

        this.$http.post(`https://app.wev.nu/api/link/upload/${this.$route.params.id}/${this.Step}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          this.CameraLoader = false
          this.Images.push({
            Identifier: response.data.identifier,
            Type: this.Step,
            raw: response.data.raw
          })
          document.querySelector('.preview').innerHTML = ''
        })
      })
    },

    SetBackground (e) {
      if(this.Images.filter(item => item.Type == e).length > 0) {
        return 'background: url(' + this.Images.filter(item => item.Type == e)[0].raw + ')'
      }
    },

    Close () {
      this.$http.get(`https://app.wev.nu/api/link/close/${this.$route.params.id}`).then(() => {
        this.Step = 'Complete'
      })
    },

    SkipStep (e) {
      if(e) {
        if(this.Skip) {
          this.Step = 'Intro'
        } else {
          this.Step = 'Client'
        }
      } else {
        if(this.Skip) {
          this.Step = 'Start'
        } else {
          this.Step = 'Client'
        }
      }
    }
  },

  watch: {
    Step (a) {
      if(this.Steps.map(item => item.ID).includes(a) || this.Step == 'DAMAGE_1' || this.Step == 'DAMAGE_2' || this.Step == 'DAMAGE_3' || this.Step == 'DAMAGE_4' || this.Step == 'DAMAGE_5') {
        if(this.Images.filter(image => image.Type == a).length == 0) {
          if(this.Mobile) {
            this.StartVideo()
          }
        }
      } else {
        this.StopVideo()
      }
    }
  }
}
</script>

<style scoped>
.link {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0b4d49;
}

.link .header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.link .header .logo {
  height: 16px;
}

.link .load {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #0b4d49;
  transition: 1s;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
}

.link .load.active {
  opacity: 1;
  pointer-events: all;
}

.link .load .logo {
  height: 16px;
}

.link .load .animation {
  width: 50%;
  height: unset;
  background: unset;
}

.link .load span {
  color: #fff;
  font-size: 20px;
  font-weight: 300;
}

.link .intro {
  padding: 0 35px;
}

.link .intro.center {
  text-align: center;
}

.link .intro span {
  font-size: 24px;
  font-weight: 300;
  color: #fff;
}

.link .intro span b {
  font-size: 24px;
  font-weight: 700;
}

.link .content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-height: calc(100% - 100px);
  margin: 50px 0 0 0;
  padding: 35px;
  border-radius: 25px 25px 0 0;
  background: #f2f2f2;
  overflow-y: auto;
}

.link .content.full {
  height: 100%;
}

.link .content .group {
  display: flex;
  flex-direction: column;
  margin: 0 0 15px 0;
}

.link .content .group .tip {
  margin: 0 0 5px 0;
}

.link .content .group input {
  padding: 15px 10px;
  font-size: 18px;
  font-weight: 700;
  border: 0;
  border-radius: 5px;
  outline: none;
}

.link .content .group input:disabled {
  background: #fff;
  opacity: 0.5;
}

.link .content .tip {
  font-size: 20px;
  font-weight: 300;
  margin: 25px 0 5px 0;
}

.link .content .licence {
  background: yellow;
  text-align: center;
  padding: 15px 35px 15px 0;
  margin: 0 0 5px 0;
  font-size: 30px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0;
  border-left: solid 35px #4c3aff;
  border-radius: 5px;
  outline: none;
}

.link .content .vehicle {
  font-size: 14px;
  font-weight: 700;
  font-style: italic;
}

.link .content .export {
  text-decoration: underline;
  color: red;
  font-weight: 700;
  font-size: 14px;
}

.link .content .mileage {
  text-align: center;
  padding: 15px 0;
  margin: 0 0 15px 0;
  font-size: 30px;
  font-weight: 700;
  border: 0;
  border-radius: 5px;
  outline: none;
  -moz-appearance: textfield;
}

.link .content .mileage::-webkit-outer-spin-button, .link .content .mileage::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.link .content .title {
  display: block;
  margin: 45px 0 15px 0;
  font-size: 22px;
  font-weight: 700;
}

.link .content .title.center {
  margin: 0 0 15px 0;
  text-align: center;
}

.link .content .captureButtons {
  display: flex;
  justify-content: space-between;
}

.link .content .captureButtons .capture {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(75% - 10px);
  height: 80px;
  background: #0b4d49;
  border-radius: 10px;
  cursor: pointer;
}

.link .content .captureButtons .capture.disabled {
  opacity: 0.25;
  pointer-events: none;
}

.link .content .captureButtons .capture svg {
  width: 25px;
  height: 25px;
  margin: 0 15px 0 0;
}

.link .content .captureButtons .capture span {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
}

.link .content .captureButtons .upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25%;
  height: 80px;
  border: dashed 1px #0b4d49;
  border-radius: 10px;
  cursor: pointer;
}

.link .content .captureButtons .upload.full {
  width: 100%;
}

.link .content .captureButtons .upload svg {
  width: 35px;
  height: 35px;
}

.link .content .captureButtons .redo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(75% - 10px);
  height: 80px;
  border: solid 1px #0b4d49;
  border-radius: 10px;
  cursor: pointer;
}

.link .content .captureButtons .redo svg {
  width: 25px;
  height: 25px;
  margin: 0 15px 0 0;
}

.link .content .captureButtons .redo span {
  font-size: 20px;
  font-weight: 500;
  color: #0b4d49;
}

.link .content .captureButtons .remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25%;
  height: 80px;
  border: dashed 1px #0b4d49;
  border-radius: 10px;
  cursor: pointer;
}

.link .content .captureButtons .remove svg {
  width: 35px;
  height: 35px;
}

.link .content .gallery {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 15px 0 0 0;
}

.link .content .gallery .image {
  width: calc(20% - 10px);
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b4d49;
  background-position: 50% !important;
  background-size: cover !important;
  border-radius: 10px;
  opacity: 0.5;
  cursor: pointer;
}

.link .content .gallery .image.active {
  opacity: 1;
}

.link .content .gallery .image .number {
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0px 0px 5px black;
}

.link .content .subtitle {
  margin: 15px 0 45px 0;
  font-size: 22px;
  font-weight: 300;
}

.link .content .subtitle.center {
  text-align: center;
}

.link .content .shutter {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  margin: 15px 0;
  background: #000;
  border-radius: 10px;
}

.link .content .shutter .empty {
  padding: 0 25px;
  text-align: center;
  color: #fff;
}

.link .content .shutter .preview {
  position: absolute;
  width: 100%;
  height: 200px;
  min-height: 200px;
  max-height: 200px;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
  z-index: 8888;
}

.link .content .shutter .captured {
  position: absolute;
  position: relative;
  width: 100%;
  height: 200px;
  min-height: 200px;
  max-height: 200px;
  border-radius: 10px;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
  z-index: 8999;

}

.link .content .shutter .captured img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.link .content .shutter .cameraGranted {
  justify-content: center;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  z-index: 7777;
}

.link .content .shutter .cameraDenied {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: center;
  padding: 0 25px;
  z-index: 7777;
}

.link .content .shutter .cameraLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  background: #000;
  border-radius: 10px;
  z-index: 8889;
}

.link .content .animation {
  width: 100%;
  height: 250px;
}

.link .content .buttons {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  height: 70px;
}

.link .content.full .buttons {
  margin-top: auto;
}

.link .content .buttons .previous {
  width: 50px;
  height: 39px;
  padding: 5px 7px 5px 3px;
  margin: 0 15px 0 0;
  border: solid 1px #333;
  border-radius: 50%;
  cursor: pointer;
}

.link .content .buttons .next {
  width: 100%;
  background: #f9d201;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  padding: 15px 0;
  margin: 35px 0 0 0;
  border: 0;
  border-radius: 15px;
  outline: none;
  cursor: pointer;
}

.link .content .buttons .next.secondary {
  background: transparent;
  border: solid 1px #0b4d49;
}

.link .content .buttons .next.disabled {
  opacity: 0.5;
  pointer-events: none;
}



@media only screen and (min-width: 600px) {
  .link {
    padding: 50px 0;
  }

  .link .load .animation {
    width: 500px;
  }

  .link .intro span {
    display: block;
    max-width: 500px;
    margin: 25px auto;
  }

  .link .content {
    position: unset;
    width: 500px;
    height: fit-content !important;
    margin: 25px auto;
    border-radius: 25px;
  }

  .link .content .shutter {
    margin: 35px 0;
  }

  .link .content .gallery {
    margin: 35px 0 0 0;
  }

  .link .content .buttons {
    height: 100px;
  }

  .link .content .buttons .previous {
    width: 45px;
  }
}
</style>